$(() => {
  const productForm = $('[data-product-form]');
  const addToCartButton = $('#js-add-to-cart-button');
  const addToCartButtonText = $('#js-add-to-cart-button-text');
  const addToCartButtonSpinner = $('#js-add-to-cart-button-spinner');

  const cartCountBubble = $('[data-cart-count-bubble]');
  const cartCount = $('[data-cart-count]');
  const cartPopup = $('.cart_popup');
  const cartPopupCloseButton = $('#js-cart-popup-close-button');
  const cartPopupProductList = $('#js-cart-popup-product-list');
  const cartPopupItemCount = $('#js-cart-popup-item-count');


  function hideCartPopup () {
    cartPopup.addClass('cart_popup_hide');
  }
  function showCartPopup () {
    cartPopup.removeClass('cart_popup_hide');
  }

  function updateCartItemCount (cartItemCount) {
    // カートアイコン 個数更新
    cartCountBubble.removeClass('p-header__cart-count--hidden');
    cartCount.text(cartItemCount);
    // カートドロワー 個数更新
    cartPopupItemCount.text(cartItemCount);
  }

  function getSizedImageUrl(src, size) {
    let match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );
    if (match !== null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];
      return (prefix[0] + '_' + size + suffix).replace(/http(s)?:/, '');
    }
    return null;
  }

  function updateCartPopupContent (items) {
    let productList = '';
    items.forEach(item => {
      // 商品オプション一覧DOM
      let optionList = '';
      if (!item.product_has_only_default_variant) {
        optionListElements = '';
        item.options_with_values.forEach(option_with_value => {
          optionListElements += `<li class="cart_popup_product_list_item_detail_option_list_item">${ option_with_value.name } : ${ option_with_value.value }</li>`
        })
        optionList = `<ul class="cart_popup_product_list_item_detail_option_list">${ optionListElements }</ul>`
      }
      // 商品DOM
      let imageUrl = getSizedImageUrl(item.featured_image.url, '200x');
      productList += `
        <li class="cart_popup_product_list_item js-cart-popup-product-list-item" id="js-cart-popup-product-list-item-${ item.id }">
          <div class="cart_popup_product_list_item_left_wrapper">
            <img src=${ imageUrl } alt="${ item.featured_image.alt }" class="cart_popup_product_list_item_image">
            <div class="cart_popup_product_list_item_detail">
              <h3 class="cart_popup_product_list_item_detail_title">${ item.product_title }</h3>
              ${ optionList }
            </div>
          </div>
          <button>
            <img
              src="https://cdn.shopify.com/s/files/1/0430/4961/5510/files/EcoSmart_Fire_cartpopup_close.svg?v=1658206623"
              class="cart_popup_product_list_item_delete_button"
              data-itemkey="${ item.key }"
              data-variantid="${ item.id }"
              >
          </button>
        </li>
      `
    });
    cartPopupProductList.html(productList);
  }

  function decrementItemInCartPopup (lineItemKey, variantID) {
    $.getJSON('/cart.js')
      .done((cart) => {
        cart.items.forEach(item => {
          if (item.key === lineItemKey) {
            let params = {
              url: '/cart/change.js',
              data: {'id': lineItemKey, 'quantity': item.quantity - 1},
              dataType: 'json'
            }
            $.post(params)
              .done((data) => {
                updateCartItemCount(data.item_count);
                $(`#js-cart-popup-product-list-item-${ variantID }`).remove();
                // 表示商品がなくなった場合はドロワーを非表示にする
                if ($('.js-cart-popup-product-list-item').length === 0) {
                  hideCartPopup();
                }
              })
          }
        })
      })
  }

  function handleButtonLoadingState (isLoading, buttonText, buttonSpinner, buttonElement) {
    if (isLoading) {
      buttonText.hide();
      buttonSpinner.show();
      buttonElement.attr('disabled', true);
    } else {
      buttonText.show();
      buttonSpinner.hide();
      buttonElement.attr('disabled', false);
    }
  }

  function handleAddToCartButtonLoadingState (isLoading) {
    handleButtonLoadingState(isLoading, addToCartButtonText, addToCartButtonSpinner, addToCartButton)
  }

  function addItemsToCart (data) {
    hideCartPopup();
    let params = {
      url: '/cart/add.js',
      data: data,
      dataType: 'json'
    }
    $.post(params)
      .done((data) => {
        $.getJSON('/cart.js')
          .done((cart) => {
            updateCartItemCount(cart.item_count);
            updateCartPopupContent([data]);
            showCartPopup();

            // 削除ボタン
            let cartPopupDecrementButtons = $('.cart_popup_product_list_item_delete_button');
            cartPopupDecrementButtons.on('click', function () {
              decrementItemInCartPopup($(this).data('itemkey'), $(this).data('variantid'))
            })
          })
      })
      .fail((response) => {
        console.log(response);
      })
      .always(() => {
        handleAddToCartButtonLoadingState(false);
      })
  }

  // カート追加ボタンが押された時
  productForm.submit(function (event) {
    event.preventDefault();
    handleAddToCartButtonLoadingState(true);
    let data = $(productForm).serialize();
    addItemsToCart(data);
  })

  cartPopupCloseButton.click(function () {
    hideCartPopup();
  })
});